import { TextPostion, IShapeTextView } from 'flux-diagram-composer';
import { Rectangle } from 'flux-core';
import { ShapeTextModel } from './../../model/text/shape-text.mdl';
import { TextView } from './text-view';
import { IPosition2D, TextAlignment, TEXT_PADDING_HORIZONTAL, ITransform } from 'flux-definition';

/**
 * This ShapeTextView extends the TextView and it contains
 * the functialities the are specific to render the texts
 * on the Shapes
 *
 * @author thisun
 * @since 2018-01-17
 */
export class ShapeTextView extends TextView implements IShapeTextView {

    /**
     * The horizontal text padding value, this amount will be added to the
     * both left and right of the text
     */
    protected horizontalTextPadding: number  = 10;
    constructor( protected model: ShapeTextModel ) {
        super( model )/* istanbul ignore next */;
    }

    /**
     * This render's the text view as per the model data
     * and config. It also positions the text view in relation
     * to the shape and updates the rotation
     * @param model ShapeTextModel
     * @param bounds Rectangle The defaulit bounds of the shape
     * @param transform The transform of the shape
     */
    public update( model: ShapeTextModel, change?: any,  bounds?: Rectangle, transfrom?: ITransform ) {
        if ( !model.isVisible ) {
            this.visible = false;
            return;
        } else {
            this.visible = true;
        }
        super.update( model, change );
        if ( bounds ) {
            const scale = transfrom ? transfrom.scaleX : 1 ;
            this.lineWidth = Math.abs( model.hitArea ? model.hitArea.width :
                 bounds.width * scale ) - ( 2 * TEXT_PADDING_HORIZONTAL );
            if ( model.width > this.lineWidth ) {
                this.lineWidth = model.width;
            }
            let textBounds;
            /*  FIXME
                The model width property dhould not be undefined,
                Text width and height should be available at this point.
                But now, text width height are stored from the TextBoundsBinder change binder and
                these valuse are not avaibale for the first time texts render.
            */
            if ( model.width !== undefined ) {
                textBounds = new Rectangle( 0, 0, model.width, model.height );
            } else if ( model.wordWrap ) {
                textBounds = this.getTextBounds( model.value, model.hitArea ? model.hitArea.width : bounds.width );
            } else {
                textBounds = this.getTextBounds( model.value );
            }
            this.position( model.position, model.alignX, model.alignY, textBounds as any, bounds, transfrom );
            this.updateHitArea( model, textBounds );
        }
        this.updateViewCache( model, change );
    }

    /**
     * This function updates the position of the text
     * considering the text model values, shape bounds and trnsformation
     *
     * @param xPos number      A ratio to define the x position on the shape
     * @param yPos number      A ratio to define the y position on the shape
     * @param alignX TextAlignment  The horizontal text alignment
     * @param alignX TextAlignment  The vertical text alignment
     * @param shapeBounds Rectangle  The default bounds of the shape
     * @param transform  ITransform  The transformation of the text
     */
    protected position (
        pos: IPosition2D,
        alignX: TextAlignment,
        alignY: TextAlignment,
        textBounds: Rectangle,
        shapeBounds: Rectangle,
        transfrom: ITransform ) {

            const bounds = { width: this.lineWidth, height: textBounds.height };
            const pointOnShape = TextPostion.getPointOnShape( pos, shapeBounds, transfrom );
            const pointOnText = TextPostion.getPointOnText( bounds as any, alignX, alignY, transfrom );
            this.regX = pointOnText.x;
            this.regY = pointOnText.y;
            this.x = pointOnShape.x;
            this.y = pointOnShape.y;
            this.applyTransform( transfrom );
    }

    /**
     * This funciton applies tranforms to the text
     * @param transform  ITransform  The transformation of the text
     */
    protected applyTransform( transfrom: ITransform ) {
        if ( transfrom ) {
            // FIXME Do Dev Testing!! CJ - 28/01/2021 - @thisun check
            this.rotation = TextPostion.getTextAngle( transfrom );
            this.rotation = this.rotation + this.model.angle;
        }
    }

}
